/* eslint-disable import/prefer-default-export */
import { createAction } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

export const purge = createAction(PURGE)
